import angular from 'angular';
import _ from 'lodash';

export default angular.module('email-notifications-templates-errorcodes', []).run([
  'appFactory',
  function errorCodes(appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      emailNotificationsTemplates: {},
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/config/errorcodes.conf.js